// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardRoutes.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import { defaults } from 'lodash/fp';
import { Route, IndexRoute } from 'react-router';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import { Container } from 'modules/Dashboard/Izenda.DashboardRoot';
import DashboardList from './DashboardList/Izenda.DashboardList';
import DashboardDesigner from './DashboardDesigner/Izenda.DashboardDesigner';

/**
 * Flag creating new dashboard whenever the route enters or changed
 * @param {any} prevState
 * @param {any} nextState
 */
const setNewDashboardDefaultState = (prevState, nextState) => {
  nextState.location.state = defaults(nextState.location.state, {
    needCreateNewDashboard: true
  });
};

const setNewDashboardNullState = setNewDashboardDefaultState.bind(null, null);

export default () => {
  const [index, list, edit, add] = [
    ['Dashboard'],
    ['Dashboard', 'List'],
    ['Dashboard', 'Edit'],
    ['Dashboard', 'New']
  ].map(route => routeUtils.getConfigRoute(route));

  return (
    <Route path={index.path} component={Container}>
      <IndexRoute component={DashboardList} />
      <Route name={list.name} path={list.path} component={DashboardList} />
      <Route
        name={add.name}
        path={add.path}
        component={DashboardDesigner}
        onEnter={setNewDashboardNullState}
        onChange={setNewDashboardDefaultState}
      />
      <Route name={edit.name} path={edit.path} component={DashboardDesigner} />
    </Route>
  );
};



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/Izenda.DashboardRoutes.js